import { createContext, useContext } from 'react';

const ClinicalFontScaleContext = createContext('1');

export function ClinicalFontScaleProvider({ scale, children }) {
  return (
    <ClinicalFontScaleContext.Provider value={scale}>{children}</ClinicalFontScaleContext.Provider>
  );
}

export function useClinicalFontScale() {
  return useContext(ClinicalFontScaleContext);
}
